import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { RemoveFormContentProps } from '../interfaces';
import RemoveButton from '../RemoveButton';
import { RootState } from 'store';
import { isLoading } from 'utils/loading';
import { removeCustomerAction } from 'modules/distributionContracts';
import { openAlert } from 'modules/alertHandler';
import { getOnlyNumbers } from 'utils/texts';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import { getFormatedCpfCnpjValue } from './helpers';

const RemoveCustomer = ({
  handleClose,
}: RemoveFormContentProps): JSX.Element => {
  const dispatch = useDispatch();

  const [customerId, setCustomerId] = useState<string | null>(null);
  const [formatType, setFormatType] = useState<string>('CPF');
  const [isValidClient, setIsValidClient] = useState<boolean>(false);

  const { customerValidLoading } = useSelector(
    (state: RootState) => state.distributionContracts,
  );

  const handleFormat = (nextValue: string): string => {
    const nextFormatType = nextValue.length <= 11 ? 'CPF' : 'CNPJ';

    if (formatType !== nextFormatType) {
      setFormatType(nextFormatType);
    }

    return getFormatedCpfCnpjValue({
      formatedType: nextFormatType,
      cpfCnpj: nextValue,
    });
  };

  const handleOnBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
  ) => {
    const customerIdNumbers = getOnlyNumbers(e.target.value) || '';
    const isValidCustomer =
      formatType === 'CPF'
        ? cpf.isValid(customerIdNumbers)
        : cnpj.isValid(customerIdNumbers);
    setCustomerId(customerIdNumbers);
    setIsValidClient(isValidCustomer);
  };

  const handleClickAtRemove = () => {
    handleClose();
    dispatch(
      openAlert({
        title: 'Remover o cliente?',
        content: `Tem certeza que deseja remover o cliente "${customerId}"?`,
        primaryButton: 'Sim',
        primaryButtonAction: removeCustomerAction({
          customerId,
        }),
        secondaryButton: 'Não',
      }),
    );
  };

  const isLoadingValidCustomer = isLoading([customerValidLoading]);

  return (
    <Grid container item direction="column" spacing={2}>
      <Grid item>
        <Typography>CPF ou CNPJ</Typography>
        <NumberFormat
          customInput={TextField}
          mask="_"
          format={handleFormat}
          disabled={isLoadingValidCustomer}
          onBlur={handleOnBlur}
          fullWidth={true}
          margin="none"
          error={customerId && !isValidClient}
          helperText={
            customerId && !isValidClient ? 'CPF ou CNPJ inválido' : ' '
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isLoadingValidCustomer && <CircularProgress size={25} />}
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid container direction="column" alignContent="center">
        <RemoveButton disabled={!isValidClient} onClick={handleClickAtRemove} />
      </Grid>
    </Grid>
  );
};

export default RemoveCustomer;
